export interface StatusCounts {
  pending: number;
  warning: number;
  success: number;
  error: number;
  total: number;
}

/**
 * Calcula totais por status a partir de uma lista de itens.
 * getStatus deve retornar a string do status (ex: "success", "error", "warning", "pending")
 * Qualquer valor falsy é tratado como "pending" para manter compatibilidade com a lógica existente.
 */
export function calculateStatusCounts<T>(
  items: T[] | undefined | null,
  getStatus: (item: T) => string | undefined | null,
): StatusCounts {
  const list = Array.isArray(items) ? items : [];
  const stats: StatusCounts = {
    pending: 0,
    warning: 0,
    success: 0,
    error: 0,
    total: list.length,
  };

  list.forEach((item) => {
    const status = getStatus(item) || "pending";
    if (status === "success") stats.success++;
    else if (status === "error") stats.error++;
    else if (status === "warning") stats.warning++;
    else stats.pending++;
  });

  return stats;
}

